































import { Component, Vue, Inject, Prop, Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import AbpBase from '../../../lib/abpbase'
import appconst from '@/lib/appconst';
import Enums from '@/lib/enums'
class AddStock {
    orderNumber: number;
    logisticsNumber: string;
    reason: string;
}
@Component
export default class CreatestockModule extends AbpBase {
    @Prop({ type: Boolean, default: false }) value: boolean;
    stock: AddStock = new AddStock();
    imgUrl: string = '';
    imgUploadUrl: string = '';
    cargoCategoryType = Enums.CargoCategoryType;
    productTypeList = Enums.ProductType;

    addLoding = false;
    amountTotal: string = '';;
 

    created() {
    }
    signFor() {
        this.save();
    }
    save() {
        (this.$refs.stockCreateForm as any).validate(async (valid: boolean) => {
            if (valid) {
                this.addLoding = true;
              
                await this.$store.dispatch({
                    type: 'fronturgentorder/CreateUrgent',
                    data: this.stock
                }).finally(() => {
                    this.addLoding = false;
                });
                (this.$refs.stockCreateForm as any).resetFields();
                this.$emit('save-success');
                this.$emit('input', false);
            }
        })
    }
  
    cancel() {
        (this.$refs.stockCreateForm as any).resetFields();
        this.$emit('input', false);
    }
    visibleChange(value: boolean) {
        if (!value) {
            this.$emit('input', value);
        } else {
        }
    }
    stockRule = {
        orderNumber: [
            { required: true, message: '订单编号不能为空', trigger: 'blur' }
        ],
    };

}
